/* eslint-disable */
import React, { Component } from "react";
import PropTypes from "prop-types";
import constants, { BOOKING_FORM_NAME_MOUNTPOINT } from "../../utils/constants";
import styles from "./BookingForm.scss";
import { BookingFormSummary } from "~/components";
import {
  CalendarIcon,
  PromoCodeIcon,
  ArrowDropDownIcon,
  GPSNotFixedIcon,
  LupaIcon,
  MenuIcon,
} from "../../theme/assets";
import classnames from "classnames";
import { defineMessages, FormattedMessage, injectIntl } from "react-intl";
import { CHILDREN_COUNT_FIELD } from "./constants";
import { Popup } from "@witbooking/react-components";
import OccupantTypeSelector from "./OccupantTypeSelector";
import OccupantsList from "./OccupantsList";
import OccupantsWrapper from "./OccupantsWrapper";
import AgeSelector from "./AgeSelector";
import { CalendarPicker } from "~/components";
import Filter from "./Filter/Filter";
import moment from "moment";
import intersection from "lodash/intersection";
import { redirectUrl, renderHTML } from "../../utils/misc";
import { dateDiffInDays } from "../../utils/date";

const msgs = defineMessages({
  avilabilityRates: {
    id: "booking_form.slogan.availability_and_rates",
    description: "Slogan upper text",
    defaultMessage: "AVAILABILITY AND RATES",
  },
  bestPriceGuarantee: {
    id: "booking_form.slogan.best_price_guarantee",
    description: "Slogan upper text",
    defaultMessage: "Best Price Guarantee",
  },
  promoCode: {
    id: "booking_form.promo_code",
    description: "Placeholder for promotion code",
    defaultMessage: "¿Code/coupon?",
  },
});

const BookingFormLogo = ({
  showLogo,
  showMobileLogo,
  logos,
  hotelSiteURL,
  showDesktopLogo,
  BookingFormMenuComponent,
}) => {
  if (!showLogo) {
    return null;
  }
  return (
    <div
      id="wbkv9-App-BookingFormLogo"
      className={classnames("wbkv9-App-BookingFormLogo", styles.BookingFormLogo)}>
      {showMobileLogo && (
        <div
          className={classnames(
            "wbkv9-App-mobileLogoContainer",
            "mobileLogoContainer",
            styles.mobileLogoContainer
          )}>
          {logos && (
            <a href={hotelSiteURL} target="_blank" id="wbk9-BookingForm-MobileHiperlink">
              <img id={"wbk9-BookingForm-MobileLogo"} src={logos.get("logoMobile").get("url")} />
            </a>
          )}

          {BookingFormMenuComponent}
        </div>
      )}
      {showDesktopLogo && (
        <div className={classnames("wbkv9-App-desktopLogoContainer", styles.desktopLogoContainer)}>
          {logos && (
            <a href={hotelSiteURL} target="_blank" id="wbk9-BookingForm-Hiperlink">
              <img id={"wbk9-BookingForm-Logo"} src={logos.get("logo").get("url")} />
            </a>
          )}
        </div>
      )}
    </div>
  );
};

const BookingFormMenu = ({ showMenu, menuButtonMarkup, openExternalMenuModal }) => {
  if (!showMenu) {
    return null;
  }

  let button = (
    <div className={classnames("wbkv9-App-BookingFormMenu", styles.BookingFormMenu)}>
      <MenuIcon />
    </div>
  );

  if (menuButtonMarkup) {
    button = (
      <div
        className="wbkv9-App-BookingFormMenu"
        dangerouslySetInnerHTML={renderHTML(menuButtonMarkup.get("code"))}
      />
    );
  }

  return (
    <div
      onClick={openExternalMenuModal}
      className={classnames("wbkv9-App-BookingFormMenuContainer", styles.BookingFormMenuContainer)}>
      {button}
    </div>
  );
};

export const labels = {
  startDate: "startDate",
  endDate: "endDate",
  seniors: "seniors",
  adults: "adults",
  teenagers: "teenagers",
  children: "children",
  babies: "babies",
  promoCodes: "promoCode",
};

function initialEstablishmentFilter(propertyFilters, activeFilters, propertyTickers) {
  let result = {};
  const propertyTickersString = propertyTickers && propertyTickers.join(",");
  const establishmentFilters =
    propertyFilters &&
    propertyFilters.filter(filter => {
      if (filter.get("options")) {
        return filter
          .get("options")
          .filter(
            option => option && option.get("type") === constants.PROPERTY_FILTER.TYPE.ESTABLISHMENT
          );
      }

      return false;
    });

  if (activeFilters) {
    activeFilters.map(activeFilter => {
      const filterSplit = activeFilter.split(",");
      if (filterSplit) {
        const filter =
          establishmentFilters &&
          establishmentFilters.find(
            establishmentFilter => establishmentFilter.get("filterTicker") === filterSplit[0]
          );
        const optionFilter =
          filter &&
          filter.get("options") &&
          filter.get("options").find(option => option.get("optionTicker") === filterSplit[1]);
        if (optionFilter) {
          result = {
            [filterSplit[0]]: optionFilter.get("pattern"),
            name: optionFilter.get("optionName"),
            optionTicker: optionFilter.get("optionTicker"),
          };
        }
      }
    });
  }

  if (propertyTickersString) {
    const hotelFilter =
      establishmentFilters &&
      establishmentFilters.find(
        filter => filter.get("filterTicker") === constants.PROPERTY_FILTER.HOTEL_FILTER
      );
    if (hotelFilter && hotelFilter.get("options")) {
      result[constants.PROPERTY_FILTER.HOTEL_FILTER] = hotelFilter.get("options").find(option => {
        let pattern = option && option.get("pattern") && option.get("pattern").toLowerCase();
        const patternSplit = pattern && pattern.split(",");
        pattern = patternSplit && patternSplit.sort();
        pattern = pattern && pattern.join(",");

        let propertyTickers = propertyTickersString.toLowerCase();
        const propertyTickersSplit = propertyTickers.split(",");
        propertyTickers = propertyTickersSplit && propertyTickersSplit.sort();
        propertyTickers = propertyTickers && propertyTickers.join(",");

        return pattern === propertyTickers;
      });

      if (result[constants.PROPERTY_FILTER.HOTEL_FILTER]) {
        result = {
          [constants.PROPERTY_FILTER.HOTEL_FILTER]: result[
            constants.PROPERTY_FILTER.HOTEL_FILTER
          ].get("pattern"),
          name: result[constants.PROPERTY_FILTER.HOTEL_FILTER].get("optionName"),
          optionTicker: result[constants.PROPERTY_FILTER.HOTEL_FILTER].get("optionTicker"),
        };
      }
    }
  }

  return result;
}

function initialUrlFilter(propertyFilters) {
  let result = null;

  const urlFilters =
    propertyFilters &&
    propertyFilters.filter(filter => filter.get("type") === constants.PROPERTY_FILTER.TYPE.URL);

  if (
    urlFilters &&
    urlFilters.get(0) &&
    urlFilters.get(0).get("options") &&
    urlFilters.get(0).get("options").get(0) &&
    urlFilters.get(0).get("options").get(0).get("pattern")
  ) {
    result = urlFilters.get(0).get("options").get(0).get("pattern");
  }

  return result;
}

const BookingFormContainer = ({
  selectedTab,
  hasFilters,
  handleSubmit,
  customSubmit,
  fieldsContainerClassName,
  generalFilters,
  establishmentFilter,
  handleGeneralFilterChange,
  startDate,
  endDate,
  today,
  handleOnChangeDates,
  deviceInfo,
  fullWidth,
  enabledSelectors,
  fields,
  totalOccupants,
  ageRanges,
  childrenCount,
  childrenAgeRange,
  guestAges,
  selectorsRange,
  submitAgeSelectorForm,
  openAgesModal,
  promoCode,
  promoCodeDisplayed,
  togglePromoCode,
  intl,
  ageSelectorsContainerClassName,
  buttonContainerClassName,
  submitting,
  isFormStateInvalid,
  isButtonBlinking,
  tabFilters,
  handleChangeTab,
  promoCodesContainerClassName,
  promoCodes,
  handleFieldsClick,
  handleOpenOverlay,
  handleCloseOverlay,
  overlayIsOpen,
  showBestPriceGuaranteed,
}) => {
  return (
    <div
      id="bookingFormContainer"
      className={classnames(
        "wbkv9-BookingForm",
        styles.container,
        "bookingFormContainer",
        selectedTab && styles.hasTabs,
        hasFilters && styles.hasFilters
      )}>
      <form onSubmit={handleSubmit(customSubmit)}>
        <div className={fieldsContainerClassName} onClick={handleFieldsClick}>
          {generalFilters && generalFilters.size > 0 && (
            <div className={classnames("wbkv9-BookingForm-filters", styles.filters)}>
              <div className={classnames("wbkv9-BookingForm-FilterIcon", styles.filterIcon)}>
                <GPSNotFixedIcon />
              </div>

              {generalFilters.map((generalFilter, idx) => (
                <Filter
                  filter={generalFilter}
                  key={idx}
                  selected={establishmentFilter && establishmentFilter.optionTicker}
                  handleChange={handleGeneralFilterChange}
                />
              ))}

              <div className={classnames("wbkv9-BookingForm-arrowDown", styles.arrowDown)}>
                <ArrowDropDownIcon />
              </div>
            </div>
          )}

          <div
            className={classnames(
              "wbkv9-BookingForm-datePickerContainer",
              styles.datePickerContainer
            )}>
            <div className={classnames("wbkv9-BookingForm-calendarIcon", styles.calendarIcon)}>
              <CalendarIcon />
            </div>
            <div
              className={classnames("wbkv9-BookingForm-inputsContainer", styles.inputsContainer)}>
              <CalendarPicker
                active
                from={startDate}
                to={endDate}
                minDate={today}
                onChange={handleOnChangeDates}
                onClean={() => ({})}
                deviceInfo={deviceInfo}
                fullWidth={fullWidth}
              />
            </div>
          </div>

          {((enabledSelectors && enabledSelectors.length > 0) || fields[CHILDREN_COUNT_FIELD]) && (
            <OccupantsWrapper
              totalOccupants={totalOccupants}
              enabledSelectors={enabledSelectors}
              fullWidth={fullWidth}
              ageRanges={ageRanges}
              fields={fields}
              childrenCount={childrenCount}
              childrenAgeRange={childrenAgeRange}
              guestAges={guestAges}
              selectorsRange={selectorsRange}
              onAgeSelectorChange={submitAgeSelectorForm}
              handleOpenOverlay={handleOpenOverlay}
              handleCloseOverlay={handleCloseOverlay}
              overlayIsOpen={overlayIsOpen}
            />
          )}

          {((enabledSelectors && enabledSelectors.length > 0) || fields[CHILDREN_COUNT_FIELD]) && (
            <div
              className={classnames(
                "wbkv9-BookingForm-selectorsContainer",
                styles.selectorsContainer
              )}>
              {enabledSelectors.map(type => {
                const minAge =
                  enabledSelectors.length > 1 &&
                  ageRanges &&
                  (ageRanges[type].min !== null || ageRanges[type].min === 0)
                    ? ageRanges[type].min
                    : null;
                const maxAge =
                  enabledSelectors.length > 1 &&
                  ageRanges &&
                  (ageRanges[type].max !== null || ageRanges[type].max === 0)
                    ? ageRanges[type].max
                    : null;

                return (
                  <OccupantTypeSelector
                    key={type}
                    field={fields[type]}
                    occupantRange={selectorsRange[type]}
                    minAge={minAge}
                    maxAge={maxAge}
                  />
                );
              })}
              {fields[CHILDREN_COUNT_FIELD] && (
                <div
                  className={classnames(
                    "wbkv9-BookingForm-childrenAgesSelector",
                    styles.childrenAgesSelector
                  )}>
                  <div
                    className={classnames(
                      "wbkv9-BookingForm-overlayAgeModalButton",
                      styles.overlayAgeModalButton
                    )}
                    onClick={event => openAgesModal(event)}></div>
                  <OccupantTypeSelector
                    disabled
                    field={fields[CHILDREN_COUNT_FIELD]}
                    occupantRange={
                      selectorsRange[CHILDREN_COUNT_FIELD] &&
                      selectorsRange[CHILDREN_COUNT_FIELD].range
                    }
                    minAge={childrenAgeRange.min}
                    maxAge={childrenAgeRange.max}
                  />
                </div>
              )}
            </div>
          )}

          {enabledSelectors.length > 0 && (
            <div
              className={classnames(
                "wbkv9-BookingForm-OccupantsList",
                styles.occupantsList,
                childrenCount > 0 && styles.hasChildrenCount
              )}>
              <OccupantsList
                enabledSelectors={enabledSelectors}
                ageRanges={ageRanges}
                fullWidth={fullWidth}
                fields={fields}
                selectorsRange={selectorsRange}
                childrenCount={childrenCount}
                guestAges={guestAges}
                childrenAgeRange={childrenAgeRange}
                onAgeSelectorChange={submitAgeSelectorForm}
              />
            </div>
          )}

          {/* Animate this with class changes */}
          {promoCode !== constants.SHOW_PROMO_CODE.HIDE && (
            <div
              className={classnames(
                promoCodesContainerClassName,
                !promoCodeDisplayed ? "" : styles.active
              )}>
              <span className={styles.promoIcon} onClick={togglePromoCode}>
                {" "}
                <PromoCodeIcon />{" "}
              </span>

              <div
                className={styles.innerContainer}
                onClick={!promoCodeDisplayed ? togglePromoCode : undefined}>
                <input
                  className={classnames(
                    "wbkv9-BookingForm-promoCodesInput",
                    styles.input,
                    !promoCodeDisplayed ? "" : styles.active
                  )}
                  placeholder={intl.formatMessage(msgs.promoCode)}
                  type="text"
                  {...promoCodes}
                />
                <span
                  className={classnames(
                    "wbkv9-BookingForm-promoCodestext",
                    styles.text,
                    !promoCodeDisplayed ? styles.active : ""
                  )}>
                  <FormattedMessage {...msgs.promoCode} />
                </span>
              </div>
            </div>
          )}

          {false &&
            fields[CHILDREN_COUNT_FIELD] &&
            fields[CHILDREN_COUNT_FIELD].value &&
            fields[CHILDREN_COUNT_FIELD].value !== "0" && (
              <div className={styles.fullRow}>
                <div className={ageSelectorsContainerClassName}>
                  {Object.keys(fields)
                    .filter(fieldName => fieldName.indexOf("age") !== -1)
                    .map(fieldName => (
                      <OccupantTypeSelector
                        key={fieldName}
                        field={fields[fieldName]}
                        occupantRange={
                          selectorsRange.childrenAges && selectorsRange.childrenAges.range
                        }
                        minAge={childrenAgeRange.min}
                        maxAge={childrenAgeRange.max}
                      />
                    ))}
                </div>
              </div>
            )}

          <div
            className={classnames(
              "wbkv9-BookingForm-buttonContainerClassName",
              buttonContainerClassName
            )}>
            <button type="submit" disabled={submitting || isFormStateInvalid}>
              <div className="text">
                <FormattedMessage {...msgs.avilabilityRates} />
              </div>
              <div className="subtext">
                {showBestPriceGuaranteed && <FormattedMessage {...msgs.bestPriceGuarantee} />}
              </div>
            </button>
          </div>

          <div
            className={classnames(
              "wbkv9-BookingForm-SearchButton",
              styles.searchButton,
              isButtonBlinking && "blinking"
            )}>
            <button
              id="bookingFormSearchButton"
              type="submit"
              disabled={submitting || isFormStateInvalid}>
              <LupaIcon />
            </button>
          </div>
        </div>
      </form>

      {!fullWidth &&
        tabFilters &&
        tabFilters.map(tabFilter => (
          <Filter filter={tabFilter} selected={selectedTab} handleChange={handleChangeTab} />
        ))}
    </div>
  );
};

/*
 * The form receives values from THREE SOURCES
 * -Initial Values (parse from url params)
 * -Own values received from interacting with the form
 * -External Values received from a special action
 * */

let component;

// TODO: expose onChangeMethods to change the value of the form fields by external components
// INSTEAD on exposing these methods, we will receive a prop EXTERNAL_DATA which can be read
// if externalData.loaded == false, then it executes the corresponding onChange functions
// to change the values of the form (This is useful for iframe integration, when we do not want
// to reload the whole app on form change)
class BookingForm extends Component {
  constructor(props) {
    super(props);
    this.today = moment(new Date()).startOf("day");
    const { initialValuesAlias } = props;
    this.state = {
      childrenCount: initialValuesAlias.childrenCount,
      guestAges: initialValuesAlias.guestAges,
      establishmentFilter: initialEstablishmentFilter(
        this.props.propertyFilters,
        this.props.activeFilters,
        this.props.propertyTickers
      ),
      urlFilter: initialUrlFilter(this.props.propertyFilters),
      bookingFormTop: null,
      overlayIsOpen: false,
    };
    this.state.promoCodeDisplayed = props.promoCode === constants.SHOW_PROMO_CODE.EXPANDED;

    this.resizeTimeout = null;

    // Binding methods
    this.handleOnChangeDates = this.handleOnChangeDates.bind(this);
    this.togglePromoCode = this.togglePromoCode.bind(this);
    this.openAgesModal = this.openAgesModal.bind(this);
    this.renderAgeModalContent = this.renderAgeModalContent.bind(this);
    this.customSubmit = this.customSubmit.bind(this);
    this.submitAgeSelectorForm = this.submitAgeSelectorForm.bind(this);
    this.openExternalMenuModal = this.openExternalMenuModal.bind(this);
    this.handleGeneralFilterChange = this.handleGeneralFilterChange.bind(this);
    this.handleSummary = this.handleSummary.bind(this);
    this.handleOnChangeFilters = this.handleOnChangeFilters.bind(this);
    this.onSummaryClose = this.onSummaryClose.bind(this);
    this.handleBookingFormSummary = this.handleBookingFormSummary.bind(this);
    this.handleFieldsClick = this.handleFieldsClick.bind(this);
    this.handleOpenOverlay = this.handleOpenOverlay.bind(this);
    this.handleCloseOverlay = this.handleCloseOverlay.bind(this);
  }

  handleOnChangeDates({ start, end }) {
    const {
      fields: { startDate, endDate },
    } = this.props;
    if (end !== undefined) {
      endDate.onChange(end);
    }
    if (start !== undefined) {
      startDate.onChange(start);
    }
  }

  handleOnChangeFilters({ value }) {
    const {
      fields: { filters },
    } = this.props;
    if (value !== undefined) {
      filters.onChange(value);
    }
  }

  openAgesModal(event) {
    const { styles: customStyle = {} } = this.props;

    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    {
    }
    const modalOptions = {
      styles: {
        backgroundColor: customStyle.backgroundColor || "#616161",
        width: "90%",
        maxWidth: 500,
        boxShadow: "0px 0px 14px 2px rgba(0,0,0,0.75)",
      },
    };

    this.props.handleModalContent(this.renderAgeModalContent(), { options: modalOptions });
  }

  openExternalMenuModal(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (this.props.isWithotel && window.self !== window.top) {
      window.parent.postMessage({ eventType: "handleMenu", action: "open" }, "*");
      return;
    }

    const modalOptions = {
      styles: {
        backgroundColor: "#616161",
        width: "90%",
        maxWidth: 500,
        boxShadow: "0px 0px 14px 2px rgba(0,0,0,0.75)",
        "margin-top": "-1px",
      },
    };

    const defaultMenu = (
      <div className={styles.defaultMenu}>
        {this.props.logos && (
          <div className={styles.defaultMenuLogo}>
            <a href={this.props.hotelSiteURL} target="_blank">
              <img src={this.props.logos.get("logo").get("url")} />
            </a>
          </div>
        )}
        <div>Aquí iría el menú web del hotel / Here goes the hotels web menu</div>
      </div>
    );

    const menu =
      (this.props.menuMarkup && (
        <div dangerouslySetInnerHTML={renderHTML(this.props.menuMarkup.get("code"))} />
      )) ||
      defaultMenu;

    this.props.handleModalContent(menu, {
      className: "wbkv9-Modal-MarkupMenu",
      options: modalOptions,
      mobileMode: true,
    });
  }

  submitAgeSelectorForm({ childrenCount, guestAges }) {
    this.setState({
      childrenCount,
      guestAges,
    });
  }
  togglePromoCode() {
    this.setState({
      promoCodeDisplayed: !this.state.promoCodeDisplayed,
    });
  }
  customSubmit() {
    const formValues = Object.entries(this.props.bookingForm)
      .map(([k, v]) => [k, v.value])
      .reduce((acc, i) => {
        //Just accumulate them all in a map.
        acc[i[0]] = i[1];
        return acc;
      }, {});

    if (
      formValues[constants.OCCUPANTS_TYPE.SENIOR] &&
      !this.props.fields[constants.OCCUPANTS_TYPE.SENIOR]
    ) {
      delete formValues[constants.OCCUPANTS_TYPE.SENIOR];
    }
    if (
      formValues[constants.OCCUPANTS_TYPE.TEENAGER] &&
      !this.props.fields[constants.OCCUPANTS_TYPE.TEENAGER]
    ) {
      delete formValues[constants.OCCUPANTS_TYPE.TEENAGER];
    }
    if (
      formValues[constants.OCCUPANTS_TYPE.CHILDREN] &&
      !this.props.fields[constants.OCCUPANTS_TYPE.CHILDREN]
    ) {
      delete formValues[constants.OCCUPANTS_TYPE.CHILDREN];
    }
    if (
      formValues[constants.OCCUPANTS_TYPE.BABY] &&
      !this.props.fields[constants.OCCUPANTS_TYPE.BABY]
    ) {
      delete formValues[constants.OCCUPANTS_TYPE.BABY];
    }

    if (this.state.urlFilter && this.state.urlFilter.url) {
      let urlFilter = this.state.urlFilter.url.split("?");
      let url = urlFilter.shift();
      if (url && url.charAt(0) === "/") {
        const currentDomain = window
          ? `${window.location.protocol}//${window.location.host}`
          : "https://engine.witbooking.com";
        url = currentDomain + url;
      }
      let query = (urlFilter && urlFilter.join("?")) || null;
      let separator = "?";

      if (query) {
        url += separator + query;
        separator = "&";
      }

      if (formValues) {
        if (formValues[constants.OCCUPANTS_TYPE.SENIOR]) {
          url += separator + "seniors=" + formValues[constants.OCCUPANTS_TYPE.SENIOR];
          separator = "&";
        }

        if (formValues[constants.OCCUPANTS_TYPE.ADULT]) {
          url += separator + "adults=" + formValues[constants.OCCUPANTS_TYPE.ADULT];
          separator = "&";
        }

        if (formValues[constants.OCCUPANTS_TYPE.TEENAGER]) {
          url += separator + "teenagers=" + formValues[constants.OCCUPANTS_TYPE.TEENAGER];
          separator = "&";
        }

        if (formValues[constants.OCCUPANTS_TYPE.CHILDREN]) {
          url += separator + "children=" + formValues[constants.OCCUPANTS_TYPE.CHILDREN];
          separator = "&";
        }

        if (formValues[constants.OCCUPANTS_TYPE.BABY]) {
          url += separator + "babies=" + formValues[constants.OCCUPANTS_TYPE.BABY];
          separator = "&";
        }

        if (formValues.startDate) {
          url += separator + "datein=" + moment(formValues.startDate).format("DD-MM-YYYY");
          separator = "&";
        }

        if (formValues.endDate) {
          url += separator + "dateout=" + moment(formValues.endDate).format("DD-MM-YYYY");
          separator = "&";
        }

        if (formValues.promoCodes) {
          url += separator + "prom=" + formValues.promoCodes;
        }
      }

      redirectUrl(url);
      return;
    }

    const mergedFormValues = formValues || {};

    if (this.state.establishmentFilter) {
      mergedFormValues.propertyTickers = this.state.establishmentFilter && {
        [constants.PROPERTY_FILTER.HOTEL_FILTER]: this.state.establishmentFilter[
          constants.PROPERTY_FILTER.HOTEL_FILTER
        ],
      };
      const arrList = Object.values(mergedFormValues.propertyTickers);
      /** TODO: Show message when intersection result is void **/
      mergedFormValues.propertyTickers = intersection(...arrList);
    }

    this.props.customSubmit({
      formValues: mergedFormValues,
      newBookingForm: this.props.bookingForm,
      childrenCount: this.state.childrenCount,
      guestAges: this.state.guestAges,
    });

    this.props.handleCloseModal();

    this.setState({ overlayIsOpen: false });
    return formValues;
  }

  onSummaryClose() {
    this.props.toggleBookingFormSummary();
  }

  renderAgeModalContent() {
    const { fields, selectorsRange, childrenAgeRange, handleCloseModal } = this.props;

    const { childrenCount, guestAges } = this.state;
    return (
      <AgeSelector
        fields={fields}
        initialChildrenCount={childrenCount}
        initialGuestAges={guestAges}
        selectorsRange={selectorsRange}
        childrenAgeRange={childrenAgeRange}
        handleCloseModal={handleCloseModal}
        onSubmit={this.submitAgeSelectorForm}
      />
    );
  }

  handleGeneralFilterChange({ event, filterTicker, optionTicker }) {
    const filter = this.props.propertyFilters
      .filter(propertyFilter => propertyFilter.get("filterTicker") === filterTicker)
      .get(0);

    const selectedOption =
      filter &&
      filter.get("options") &&
      filter
        .get("options")
        .filter(option => option.get("optionTicker") === optionTicker)
        .get(0);

    const type = selectedOption.get("type") || filter.get("type");
    const name = selectedOption.get("optionName");
    const pattern = selectedOption.get("pattern");

    switch (type) {
      case constants.PROPERTY_FILTER.TYPE.ESTABLISHMENT:
        const establishmentFilter = this.state.establishmentFilter;
        establishmentFilter[filterTicker] = pattern && pattern.split(",");
        establishmentFilter.name = name;
        establishmentFilter.optionTicker = selectedOption.get("optionTicker");
        this.setState({ establishmentFilter });
        break;

      case constants.PROPERTY_FILTER.TYPE.URL:
        this.setState({ urlFilter: { url: pattern, name: name } });
        break;

      default:
        break;
    }

    this.handleOnChangeFilters({ value: pattern });
  }

  handleSummary(element) {
    this.props.handleModalContent(
      <Popup closeWindow={this.props.handleCloseModal}>{element}</Popup>,
      {
        mobileMode: true,
        hideCloseButton: true,
        className: "wbkv9-BookingForm-Modal",
        onClose: this.onSummaryClose,
      }
    );
  }

  handleBookingFormSummary() {
    this.props.toggleBookingFormSummary();
    this.props.handleWithotelMenu("close");
  }

  handleFieldsClick() {
    this.props.handleWithotelMenu("close");
  }

  handleOpenOverlay() {
    this.setState({ overlayIsOpen: true });
  }

  handleCloseOverlay() {
    this.setState({ overlayIsOpen: false });
  }

  componentDidUpdate(prevProps) {
    if (
      window.innerWidth > 984 &&
      !this.props.ariLoading &&
      prevProps.bookingForm &&
      this.props.bookingForm &&
      this.props.bookingForm.endDate.value &&
      prevProps.bookingForm.endDate.value !== undefined &&
      dateDiffInDays(prevProps.bookingForm.endDate.value, this.props.bookingForm.endDate.value) !==
        0
    ) {
      this.props.handleSubmit(this.customSubmit)();
      this.props.handleCloseModal();
    }
  }

  componentDidMount() {
    const bookingFormLogo = document.getElementById("wbkv9-App-BookingFormLogo");
    const bookingFormLogoBottom =
      (bookingFormLogo &&
        bookingFormLogo.getBoundingClientRect() &&
        bookingFormLogo.getBoundingClientRect().bottom) ||
      0;

    const bookingFormSummary = document.getElementById("wbkv9-BookingForm-Summary");
    const bookingFormSummaryBottom =
      (bookingFormSummary &&
        bookingFormSummary.getBoundingClientRect() &&
        bookingFormSummary.getBoundingClientRect().height) ||
      0;

    if (bookingFormLogoBottom) {
      this.setState({ bookingFormTop: bookingFormLogoBottom + bookingFormSummaryBottom });
    }
  }

  render() {
    const {
      fields: { startDate, endDate, promoCodes },
      fields,
      handleSubmit,
      submitting,
      selectorsRange,
      childrenAgeRange,
      ageRanges,
      styles: customStyle = {},
      intl,
      pristine,
      promoCode,
      propertyTabs,
      selectedTab,
      handleChangeTab,
      propertyFilters,
      deviceInfo,
      showLogo,
      showMobileLogo,
      logos,
      hotelSiteURL,
      showDesktopLogo,
      fullWidth,
      intl: { formatDate },
      showMenu,
      showBookingForm,
      menuButtonMarkup,
      isBookingFormSummaryOpened,
      showBestPriceGuaranteed,
    } = this.props;
    const isFormStateInvalid = !startDate.value || !endDate.value;
    const {
      promoCodeDisplayed,
      establishmentFilter,
      urlFilter,
      childrenCount,
      guestAges,
      bookingFormTop,
      overlayIsOpen,
    } = this.state;

    const {
      togglePromoCode,
      handleGeneralFilterChange,
      openExternalMenuModal,
      submitAgeSelectorForm,
      handleSummary,
      handleBookingFormSummary,
      handleFieldsClick,
      handleOpenOverlay,
      handleCloseOverlay,
    } = this;

    const enabledSelectors = Object.values(constants.OCCUPANTS_TYPE).filter(type => fields[type]);

    const fieldsContainerClassName = classnames(
      styles.fieldsContainer,
      "wbkv9-BookingForm-fieldsContainer"
    );
    const promoCodesContainerClassName = classnames(
      "promoCodesContainer",
      "wbkv9-BookingForm-promoCodesContainer"
    );
    const ageSelectorsContainerClassName = classnames(
      styles.ageSelectorsContainer,
      "wbkv9-BookingForm-ageSelectorsContainer"
    );
    const isButtonDisabled = submitting || isFormStateInvalid;
    const isButtonBlinking = !pristine && !isButtonDisabled;
    const buttonContainerClassName = classnames(
      "buttonContainer",
      isButtonDisabled && "disabled",
      isButtonBlinking && "blinking"
    );

    const generalFilters =
      propertyFilters &&
      propertyFilters.filter(
        filter => filter.get("representation") !== constants.PROPERTY_FILTER.REPRESENTATION.TAB
      );
    const tabFilters =
      propertyFilters &&
      propertyFilters.filter(
        filter => filter.get("representation") === constants.PROPERTY_FILTER.REPRESENTATION.TAB
      );

    let totalOccupants = childrenCount || 0;
    if (enabledSelectors) {
      enabledSelectors.map(selector => {
        totalOccupants +=
          (fields[selector] && fields[selector].value && parseInt(fields[selector].value, 10)) || 0;

        return false;
      });
    }

    const formattedStartDate =
      formatDate(this.props.startDate, { day: "2-digit" }) +
      " " +
      formatDate(this.props.startDate, { month: "short" }).substring(0, 3);
    const formattedEndDate =
      formatDate(this.props.endDate, { day: "2-digit" }) +
      " " +
      formatDate(this.props.endDate, { month: "short" }).substring(0, 3);

    const firstSelectedFilter =
      (establishmentFilter && establishmentFilter.name) ||
      (urlFilter && urlFilter.name) ||
      (generalFilters &&
        generalFilters.get(0) &&
        generalFilters.get(0).get("options") &&
        generalFilters.get(0).get("options").get(0) &&
        generalFilters.get(0).get("options").get(0).get("optionName"));

    const hasFilters = generalFilters && generalFilters.size > 0;

    if (isBookingFormSummaryOpened) {
      handleSummary(
        <div className={classnames("wbkv9-BookingForm-wrapper", styles.bookingFormWrapper)}>
          <BookingFormContainer
            selectedTab={selectedTab}
            hasFilters={hasFilters}
            handleSubmit={handleSubmit}
            customSubmit={this.customSubmit}
            fieldsContainerClassName={fieldsContainerClassName}
            generalFilters={generalFilters}
            establishmentFilter={establishmentFilter}
            handleGeneralFilterChange={handleGeneralFilterChange}
            startDate={this.props.startDate}
            endDate={this.props.endDate}
            today={this.today}
            handleOnChangeDates={this.handleOnChangeDates}
            deviceInfo={deviceInfo}
            fullWidth={fullWidth}
            enabledSelectors={enabledSelectors}
            fields={fields}
            totalOccupants={totalOccupants}
            ageRanges={ageRanges}
            childrenCount={childrenCount}
            childrenAgeRange={childrenAgeRange}
            guestAges={guestAges}
            selectorsRange={selectorsRange}
            submitAgeSelectorForm={submitAgeSelectorForm}
            openAgesModal={this.openAgesModal}
            promoCode={promoCode}
            promoCodeDisplayed={true}
            togglePromoCode={togglePromoCode}
            intl={intl}
            ageSelectorsContainerClassName={ageSelectorsContainerClassName}
            buttonContainerClassName={buttonContainerClassName}
            submitting={submitting}
            isFormStateInvalid={isFormStateInvalid}
            isButtonBlinking={isButtonBlinking}
            tabFilters={tabFilters}
            handleChangeTab={handleChangeTab}
            promoCodesContainerClassName={promoCodesContainerClassName}
            promoCodes={promoCodes}
            handleFieldsClick={handleFieldsClick}
            handleOpenOverlay={handleOpenOverlay}
            handleCloseOverlay={handleCloseOverlay}
            overlayIsOpen={overlayIsOpen}
          />
        </div>
      );
    }

    const hasMenuMarkup =
      showMenu &&
      ((this.props.menuMarkup && this.props.menuMarkup.get("code")) || this.props.isWithotel) &&
      true;

    return (
      <div
        className={classnames("wbkv9-BookingForm-wrapper", styles.bookingFormWrapper)}
        style={{ backgroundColor: customStyle.backgroundColor }}>
        <BookingFormLogo
          showLogo={showLogo}
          showMobileLogo={showMobileLogo}
          showDesktopLogo={showDesktopLogo}
          logos={logos}
          hotelSiteURL={hotelSiteURL}
          fullWidth={fullWidth}
          BookingFormMenuComponent={
            hasMenuMarkup &&
            fullWidth && (
              <BookingFormMenu
                showMenu={hasMenuMarkup}
                menuButtonMarkup={menuButtonMarkup}
                openExternalMenuModal={openExternalMenuModal}
              />
            )
          }
        />
        {showBookingForm && (
          <div
            id="wbkv9-BookingForm-Summary"
            className={classnames("wbkv9-BookingForm-Summary", styles.summary)}>
            <BookingFormSummary
              hasFilters={hasFilters}
              onClick={handleBookingFormSummary}
              info={{
                destination: firstSelectedFilter,
                dates: formattedStartDate + " - " + formattedEndDate,
                occupants: totalOccupants,
              }}
            />
          </div>
        )}

        {showBookingForm && (
          <div
            className={classnames(
              "wbkv9-BookingForm-MainBookingFormContainer",
              styles.mainBookingFormContainer
            )}>
            <BookingFormContainer
              selectedTab={selectedTab}
              hasFilters={hasFilters}
              handleSubmit={handleSubmit}
              customSubmit={this.customSubmit}
              fieldsContainerClassName={fieldsContainerClassName}
              generalFilters={generalFilters}
              establishmentFilter={establishmentFilter}
              handleGeneralFilterChange={handleGeneralFilterChange}
              startDate={this.props.startDate}
              endDate={this.props.endDate}
              today={this.today}
              handleOnChangeDates={this.handleOnChangeDates}
              deviceInfo={deviceInfo}
              fullWidth={fullWidth}
              enabledSelectors={enabledSelectors}
              fields={fields}
              totalOccupants={totalOccupants}
              ageRanges={ageRanges}
              childrenCount={childrenCount}
              childrenAgeRange={childrenAgeRange}
              guestAges={guestAges}
              selectorsRange={selectorsRange}
              submitAgeSelectorForm={submitAgeSelectorForm}
              openAgesModal={this.openAgesModal}
              promoCode={promoCode}
              promoCodeDisplayed={promoCodeDisplayed}
              togglePromoCode={togglePromoCode}
              intl={intl}
              ageSelectorsContainerClassName={ageSelectorsContainerClassName}
              buttonContainerClassName={buttonContainerClassName}
              submitting={submitting}
              isFormStateInvalid={isFormStateInvalid}
              isButtonBlinking={isButtonBlinking}
              tabFilters={tabFilters}
              handleChangeTab={handleChangeTab}
              promoCodesContainerClassName={promoCodesContainerClassName}
              promoCodes={promoCodes}
              handleFieldsClick={handleFieldsClick}
              handleOpenOverlay={handleOpenOverlay}
              handleCloseOverlay={handleCloseOverlay}
              overlayIsOpen={overlayIsOpen}
              showBestPriceGuaranteed={showBestPriceGuaranteed}
            />
          </div>
        )}

        {hasMenuMarkup && (
          <BookingFormMenu
            showMenu={hasMenuMarkup}
            menuButtonMarkup={menuButtonMarkup}
            openExternalMenuModal={openExternalMenuModal}
          />
        )}
      </div>
    );
  }
}

BookingForm.propTypes = {
  maxBookableNights: PropTypes.number,
  showExpandedPromCodeInput: PropTypes.bool,
  availableHotels: PropTypes.array,
  extraFilters: PropTypes.object,
  fields: PropTypes.object.isRequired,
  selectorsRange: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  styles: PropTypes.object,
  fullWidth: PropTypes.bool,
  showBestPriceGuaranteed: PropTypes.bool,
};

// The Form component receives its initialValues and enabled Fields
// as well as some properties to render info.
export default injectIntl(BookingForm);
